export const CHECKED_ICON = 'checkbox';
export const UNCHECKED_ICON = 'checkbox-unchecked';
export const CHECKED_DISABLED_ICON = 'checkbox';
export const UNCHECKED_DISABLED_ICON = 'checkbox-unchecked';
export const CHECKED_CIRCLE_DISABLED_ICON = 'check-circle';
export const UNCHECKED_CIRCLE_DISABLED_ICON = 'radio-unchecked';
export const CHECKED_CIRCLE_ICON = 'check-circle';
export const UNCHECKED_CIRCLE_ICON = 'radio-unchecked';
